import { render } from "./PageFooter.vue?vue&type=template&id=67eebc42"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=67eebc42&lang=scss"

import exportComponent from "/opt/build/repo/sleeper-trader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__